module.exports = __webpack_public_path__ + "img/reply.b194c660.svg";